{
  "title": "Customer Overview",
  "options": {
    "accounts": "Accounts",
    "fees": "Fees",
    "information": "General Information",
    "individuals": "Individuals",
    "documents": "Documents",
    "counterparties": "Counterparties"
  },
  "information": {
    "title": "Customer Details",
    "physicaladdress": {
      "title": "Physical Address"
    },
    "registeredaddress": {
      "title": "Registered Address"
    },
    "kycprofile": {
      "title": "KYC Profile"
    },
    "investmentprofile": {
      "title": "Investment Profile"
    }
  },
  "counterparties": {
    "title": "Counterparties",
    "generalinformation": {
      "title": "General Information"
    },
    "accountinformation": {
      "title": "Account Information"
    }
  },
  "individuals": {
    "title": "Individual Information",
    "mailingaddress": {
      "title": "Mailing Address"
    }
  },
  "accounts": {
    "id": "ID",
    "status": "Status",
    "asset": "Asset",
    "availablebalance": "Available Balance",
    "currentbalance": "Current Balance",
    "fees": {
      "title": "Fees",
      "swift": "SWIFT",
      "swiftin": "SWIFT In",
      "domestic": "Domestic",
      "domesticin": "Domestic In",
      "processingfee": "Processing Fee",
      "conversionfee": "Conversion Fee",
      "ach": "ACH"
    }
  },
  "transactions": {
    "title": "Transactions",
    "fields": {
      "id": "ID",
      "date": "Date",
      "amount": "Amount",
      "type": "Type",
      "sender": "Sender/Receiver"
    }
  },
  "charts": {
    "wires": {
      "title": "Transaction Volume",
      "subtitle": "Account volume for transfers in, transfers out and fees charged"
    }
  },
  "details": {
    "id": "ID",
    "status": "Status",
    "telephone_number": "Telephone Number",
    "email_address": "Email Address",
    "address_line1": "Address Line 1",
    "address_line2": "Address Line 2",
    "address_line3": "Address Line 3",
    "city": "City",
    "state": "State",
    "postal_code": "Postal Code",
    "country_code": "Country Code",
    "description_of_business_nature": "Description of Business Nature",
    "business_jurisdictions": "Business Jurisdictions",
    "funds_send_receive_jurisdictions": "Funds Send Receive Jurisdictions",
    "engage_in_activities": "Engage in Activities",
    "regulated_status": "Regulated Status",
    "primary_source_of_funds": "Primary Source of Funds",
    "usd_value_of_fiat": "USD Value of Fiat",
    "usd_value_of_crypto": "USD Value of Crypto",
    "monthly_crypto_investment_deposit": "Monthly Crypto Investment Deposit",
    "monthly_investment_deposit": "Monthly Investment Deposit",
    "monthly_crypto_deposits": "Monthly Crypto Deposits",
    "monthly_deposits": "Monthly Deposits",
    "monthly_crypto_investment_withdrawal": "Monthly Crypto Investment Withdrawal",
    "monthly_investment_withdrawal": "Monthly Investment Withdrawal",
    "monthly_crypto_withdrawals": "Monthly Crypto Withdrawals",
    "monthly_withdrawals": "Monthly Withdrawals",
    "registered_name": "Registered Name",
    "name": "Name",
    "trading_name": "Trading Name",
    "registered_number": "Registered Number",
    "website_address": "Website Address",
    "state_of_incorporation": "State of Incorporation",
    "country_of_incorporation": "Country of Incorporation",
    "corporate_entity_type_description": "Corporate Entity Type Description",
    "corporate_entity_type": "Corporate Entity Type",
    "established_on": "Established On",
    "naics": "NAICS",
    "naics_description": "NAICS Description",
    "first_name": "First Name",
    "middle_name": "Middle Name",
    "last_name": "Last Name",
    "tax_reference_number": "Tax Reference Number",
    "date_of_birth": "Date of Birth",
    "percentage_ownership": "Percentage Ownership",
    "title": "Title",
    "individual_type": "Individual Type",
    "citizenship": "Citizenship",
    "passport_number": "Passport Number",
    "nationality": "Nationality",
    "occupation": "Occupation",
    "employment_status": "Employment Status",
    "employer_name": "Employer Name",
    "unit_number": "Unit Number",
    "registered_address_address_line1": "Registered Address - Address Line 1",
    "registered_address_address_line2": "Registered Address - Address Line 2",
    "registered_address_address_line3": "Registered Address - Address Line 3",
    "registered_address_city": "Registered Address - City",
    "registered_address_state": "Registered Address - State",
    "registered_address_postal_code": "Registered Address - Postal Code",
    "registered_address_country_code": "Registered Address - Country Code",
    "registered_address_unit_number": "Registered Address - Unit Number",
    "mailing_address_address_line1": "Mailing Address - Address Line 1",
    "mailing_address_address_line2": "Mailing Address - Address Line 2",
    "mailing_address_address_line3": "Mailing Address - Address Line 3",
    "mailing_address_city": "Mailing Address - City",
    "mailing_address_state": "Mailing Address - State",
    "mailing_address_postal_code": "Mailing Address - Postal Code",
    "mailing_address_country_code": "Mailing Address - Country Code",
    "mailing_address_unit_number": "Mailing Address - Unit Number",
    "physical_address_address_line1": "Physical Address - Address Line 1",
    "physical_address_address_line2": "Physical Address - Address Line 2",
    "physical_address_address_line3": "Physical Address - Address Line 3",
    "physical_address_city": "Physical Address - City",
    "physical_address_state": "Physical Address - State",
    "physical_address_postal_code": "Physical Address - Postal Code",
    "physical_address_country_code": "Physical Address - Country Code",
    "physical_address_unit_number": "Physical Address - Unit Number",
    "iban": "IBAN",
    "swift_bic": "SWIFT BIC",
    "routing_number": "Routing Number",
    "account_number": "Account Number",
    "type": "Account Type",
    "institution_name": "Institution Name",
    "asset_type_id": "Asset Type ID",
    "email": "Email",
    "phone_number": "Phone Number",
    "line_of_business": "Line of Business",
    "relationship_to_customer": "Relationship to Customer",
    "profile_type": "Profile Type",
    "rails": "Rails",
    "description": "Description",
    "counterparty_type": "Counterparty Type",
    "primary_business": "Primary Business",
    "customer_type": "Customer Type"
  }
}
